/**
 * @generated SignedSource<<ad5d3946ec2dc3780c76a9f2edf84179>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ticketNotificationsQuery$variables = {
  first?: number | null;
  unreadOnly?: boolean | null;
};
export type ticketNotificationsQuery$data = {
  readonly viewer: {
    readonly ticketNotifications: {
      readonly unreadCount: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly type: string;
          readonly read: boolean;
          readonly createdAt: string | null;
          readonly ticketId: string;
          readonly actorName: string | null;
          readonly ticketSubject: string | null;
          readonly watchedEvent: string | null;
          readonly actorPersonId: string | null;
        } | null;
      } | null> | null;
    };
  } | null;
};
export type ticketNotificationsQuery = {
  variables: ticketNotificationsQuery$variables;
  response: ticketNotificationsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unreadOnly"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "unreadOnly",
      "variableName": "unreadOnly"
    }
  ],
  "concreteType": "TicketNotificationConnection",
  "kind": "LinkedField",
  "name": "ticketNotifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketNotificationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketNotification",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "read",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ticketId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actorName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ticketSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "watchedEvent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actorPersonId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ticketNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ticketNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7838eeb59306f633c6aa9bacbb8afa78",
    "id": null,
    "metadata": {},
    "name": "ticketNotificationsQuery",
    "operationKind": "query",
    "text": "query ticketNotificationsQuery(\n  $first: Int\n  $unreadOnly: Boolean\n) {\n  viewer {\n    ticketNotifications(first: $first, unreadOnly: $unreadOnly) {\n      unreadCount\n      edges {\n        node {\n          id\n          type\n          read\n          createdAt\n          ticketId\n          actorName\n          ticketSubject\n          watchedEvent\n          actorPersonId\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c263c88cc8aa7e85b6ce56b906fc576e";

export default node;
